import { useState } from 'react';
import { TextField } from '@mui/material';

interface ModuleTitleInputProps {
  moduleKey: string;
  value: string;
  defaultTitle: string;
  onChange: (moduleKey: string, title: string) => void;
}

export function ModuleTitleInput({
  moduleKey,
  value,
  defaultTitle,
  onChange,
}: ModuleTitleInputProps) {
  const [isFocused, setIsFocused] = useState(false);
  const [draft, setDraft] = useState('');

  const displayValue = isFocused ? draft : value || defaultTitle;

  function commitTitle(nextValue: string) {
    const trimmed = nextValue.trim();
    onChange(moduleKey, trimmed || defaultTitle);
  }

  function handleFocus(event: React.FocusEvent<HTMLInputElement>) {
    setIsFocused(true);
    setDraft(value || defaultTitle);
    event.target.select();
  }

  function handleBlur() {
    setIsFocused(false);
    commitTitle(draft);
  }

  function handleChange(nextValue: string) {
    setDraft(nextValue);
    commitTitle(nextValue);
  }

  return (
    <TextField
      size="small"
      label="Titel"
      value={displayValue}
      onFocus={handleFocus}
      onBlur={handleBlur}
      onChange={(event) => handleChange(event.target.value)}
      onClick={(event) => event.stopPropagation()}
      onPointerDown={(event) => event.stopPropagation()}
      sx={{ minWidth: 180 }}
    />
  );
}
